<template>
    <div class="cart__table cart-table cart__kit-table">
        <table class="cart-table__table">
            <thead class="cart-table__head">
                <tr class="cart-table__row">
                <th class="cart-table__column cart-table__column--image">Image</th>
                <th class="cart-table__column cart-table__column--quantity">Quantity</th>										
                <th class="cart-table__column cart-table__column--product">Product</th>	
                <th class="cart-table__column cart-table__column--kit-size">Size</th>
                <th class="cart-table__column cart-table__column--numeral">Availability</th>
                <th class="cart-table__column cart-table__column--price">Price</th>
                <th class="cart-table__column cart-table__column--total">Total</th>
                <th class="cart-table__column cart-table__column--remove"></th>
                </tr>
            </thead>
            <tbody class="cart-table__body">
                <product-list-item v-for="(kit, index) in cart_items"
                    :key="index"
                    :index="index"
                    :kit_product="kit"
                    @viewAlternative="productAlternatives"
                    @changed_qty="changed_qty"
                    @delete-item="removeItem"
                    @kit_item_change="kit_item_change"
                    @change_size="change_size"
                    @remove-alternatives="removeAlternatives"
                    :ref="setItemRef">
                </product-list-item>
            </tbody>    
            <tfoot>

            </tfoot>
        </table>		                  			
    </div>

    <div class="block-space block-space--layout--divider-15"></div>
    <!-- optionals -->
    <optionals v-if="opt_items.length > 0" 
        :optionals="opt_items"
        @opt_ltotal="opt_linetotal">
    </optionals>
    
    <product-alternative
        :show="showAlternative"
        :alternatives="alternatives"
        :sequence="sequence"
        :size_sel='size_sel'
        @close="showAlternative = false"
        @select-alternative="alternative_item"
    >
    </product-alternative>
    
</template>

<script>
import ProductListItem from './ProductListItem.vue';
import ProductAlternative from './ProductAlternative.vue';
import Optionals from './Optionals.vue';

export default {
    components: {ProductListItem, ProductAlternative, Optionals},
    data() {
        return {
            showAlternative: false,
            prod_alternatives: [],
            kit_gtotal: 0,
            optTotal: 0,
            cart_items: this.kit_items,
            opt_items: this.optional_items,
            sequence: 0,
            selectedItemIndex: null,
            itemRefs: [],
            changed_sizes: [],
        }
    },

    props: {
        isAddToCart : {
            type: Boolean
        },
        kit_items: {
            type: Array
        },
        kit_sizes: {
            type: Array
        },
        kit_info: {
            type: Object
        },
        optional_items: {
            type: Array
        }
    },
    computed: {
    },
    emits: ['count_total', 'addedToCart'],
    methods: {

        productAlternatives(kit, size_sel) {
            this.size_sel = size_sel;
            this.alternatives = kit.alternatives;
            // console.log(this.alternatives);
            this.showAlternative = true;
            // this.sequence = KCSEQN;
        },

        /**
         * KIT MASTER to add to the cart
         */
        kitToCart() {

            // get the kit item components that has quantity > 0
            const kitc_items = this.cart_items.filter(c => c.quantity > 0);
            console.log(kitc_items);
            const opt_items = this.opt_items.filter(c => c.quantity > 0);

            // loop through kit items
            // check in changed sizes if the item has change on sizes
            let kitc_qty = 0;
            kitc_items.forEach((kitem, index) => {
                kitc_qty += kitem.quantity;
                const sizeItem = this.changed_sizes.find(i => i.index == index );
                // console.log(sizeItem);
                // change the properties that has changed for the selected size item
                if(sizeItem){
                    kitem.item = sizeItem.item;
                    kitem.yourprice = sizeItem.yourprice;
                    kitem.linetotal = sizeItem.linetotal;
                }
            });

            opt_items.forEach((i, index) => {
                kitc_qty += i.quantity;
                const hasChanged = this.changed_sizes.find(i => i.index == index );
                if(hasChanged){
                    i.item = hasChanged.item;
                }
                i.linetotal = i.quantity * i.yourprice;
                kitc_items.push(i);
            });

            // console.table(kitc_items);

            const kit = {
                kitnumber   : this.$route.params.kitnumber,
                mfgcode     : this.$route.params.manufacturer,
                EKKITF      : 'M',
                kitqy       : 1,
                quantity    : kitc_qty,
                backorder   : '',
                corecharge  : this.kit_info.corecharge,
                yourprice   : this.kit_info.yourprice,
                kit_gtotal  : this.kit_gtotal,
                desc        : this.kit_info.desc,
                image       : this.kit_info.image,
                sku         : this.kit_info.item,
                carrier     : '',

                locationid      : this.kit_info.locationid,
                locationname    : this.kit_info.locationname,
                locationcity    : this.kit_info.locationcity,
                locationstate   : this.kit_info.locationstate,

                kit_items   : kitc_items,
            };

            // console.log(kit);

            this.$store.dispatch("cart/kitToCart", kit);
        },

        countTotal() {
            // console.log(this.cart_items);
            this.kit_gtotal = 0;

            this.cart_items.forEach((kit,ciIndx)  => {
                // console.log(kit);
                if(kit.quantity == undefined){
                    kit.quantity = kit.req_qty;
                }
                const linetotal = kit.quantity * kit.yourprice;
                kit.linetotal = linetotal;
                this.kit_gtotal += kit.quantity * kit.yourprice;

                this.itemRefs[ciIndx].refMethod();
            });

            const opt_items = this.opt_items.filter(c => c.quantity > 0);

            opt_items.forEach((i, index) => {
                const hasChanged = this.changed_sizes.find(i => i.index == index );
                if(hasChanged){
                    i.item = hasChanged.item;
                }
                i.linetotal = i.quantity * i.yourprice;
                this.kit_gtotal += i.linetotal;
            });

            this.$emit('count_total', this.kit_gtotal);

            console.log('countTotal KIT TOTAL = ' + this.kit_gtotal);
        },

        /** 
         * create a reference on the child component 
         * this is to call the method of the child comp
        */
        setItemRef(el) {
            if (el) {
                this.itemRefs.push(el)
            }
        },

        /**
         * kit item event listener
         * update kit quantity
         */
        changed_qty(kit, qty) {
            this.kit_gtotal = 0;
            this.cart_items.forEach(k => {
                if(k.item == kit.item){
                    k.quantity = qty;
                    // k.qty_perkit   = qty;
                    // console.log(k);
                }
                const linetotal = k.quantity * k.yourprice;
                k.linetotal = linetotal;
                // console.log('linetotal = ' + linetotal);
                this.kit_gtotal += linetotal;
            });

            this.$emit('count_total', this.kit_gtotal);

            // console.log('changed_qty KIT TOTAL = ' + this.kit_gtotal);
        },

        /**
         * update kit master qty 
         * should multiply the the qty of kit components
         */
        changed_cartitems(newVal) {
            // const newcartitems = this.cart_items;
            // this.cart_items = [];
            // let items = [];
            this.kit_gtotal = 0;

            this.cart_items.forEach((k,i) => {
                // console.log('perkit = ' + k.qty_perkit);
                const newQty = k.qty_perkit * newVal;
                let kit = k;
                kit.quantity = newQty;
                this.cart_items[i].quantity = newQty;
                // this.cart_items.push(kit);

                // console.log(i);
                this.itemRefs[i].refMethod();
                
                const linetotal = newQty * k.yourprice;
                this.kit_gtotal += linetotal;
            });

            this.$emit('count_total', this.kit_gtotal);
        },

        /**
         * kit item change size
         * push/update change_sizes to all the changes on size
         */
        kit_item_change(kitem, ki_index) {
            const hasChanged = this.changed_sizes.find(i => i.index == ki_index);
            if(!hasChanged){
                // set the size properties for the add to cart.
                this.changed_sizes.push({
                    'item': kitem.kit_item,
                    'yourprice': kitem.kit_yourprice,
                    'linetotal': kitem.kit_yourprice * kitem.kit_quantity,
                    'index': ki_index,
                });
            }else{
                this.changed_sizes.forEach(cs => {
                    if(cs.index == ki_index){
                        cs.item = kitem.kit_item
                    }
                });
            }
        },

        /**
         *  kit item selected alternative
         */
        alternative_item(alt_item, alt_options) {

            if(alt_item == null){
                return;
            }
            // console.log(alt_item);
            // console.log(alt_options);
            let defaultItem;
            let ciIndx;
            let item_alternatives = [];
            const selected_alt = alt_options.find(a => a.item == alt_item);
            const kitems = this.kit_items;
            // console.log(selected_alt);
            // console.log(kitems);
            kitems.forEach((ci, ci_index) => {
                if(ci.KCSEQN == selected_alt.KCSEQN){
                    
                    if(ci.defaultItem == null){
                        // alert('default item is null');
                        defaultItem = ci;
                        defaultItem.alternatives = ci.alternatives;
                    }else{
                        // alert('default item is not null');
                        defaultItem = ci.defaultItem;
                    }

                    ciIndx = ci_index;
                    item_alternatives = ci.alternatives.filter(a => a.item != alt_item);
                    // update the alternatives so it'll replace the alternative on the dialog box and remove the selected alternative items
                    // ci.alternatives = [];
                    // item_alternatives.push(ci);
                    console.log(defaultItem);
                    return;
                }
            });

            // update the cart index from the selected alternative product
            this.cart_items[ciIndx] = selected_alt;
            this.cart_items[ciIndx].alternatives = item_alternatives;
            this.cart_items[ciIndx].defaultItem = defaultItem;
            // console.log(this.cart_items[ciIndx]);

            this.countTotal();
        },

        removeAlternatives(alt_item){
            // console.log(alt_item);

            const kitems = this.kit_items;
            let ciIndx;
            // console.log(kitems);

            kitems.forEach((ci, ci_index) => {
                if(ci.item == alt_item.item){
                    ciIndx = ci_index;
                }
            })

            this.cart_items[ciIndx] = alt_item.defaultItem;
            this.cart_items[ciIndx].alternatives = alt_item.defaultItem.alternatives;
            this.cart_items[ciIndx].defaultItem = null;

            this.countTotal();

            // this.alternative_item(alt_item.origItem, alt_item.alternatives);
        },

        change_size(kit_size, qty) {
            // console.log(kit_size);
            this.cart_items.forEach((k, i) => {
                // update the item on the cart depends on the selected size properties
                if(k.item == kit_size.QITEMNUM){
                    this.cart_items[i].stockquantity = kit_size.stockquantity;
                    this.cart_items[i].quantity = qty;
                    this.cart_items[i].yourprice = kit_size.EIEXCP;
                    this.cart_items[i].linetotal = kit_size.EIEXCP * qty;
                }
            });
            // count the grand total
            this.countTotal();
        },

        opt_linetotal(opt, opt_total){
            this.opt_total = 0;
            this.opt_items.forEach(k => {

                if(k.sku == opt.sku){
                    k.quantity = opt.quantity;
                }
                const linetotal = k.quantity * k.yourprice;
                // console.log('plist linetotal = ' + linetotal)
                k.linetotal = linetotal;
            });

            this.optTotal = opt_total;
            this.countTotal();
        },

        opt_total() {
            this.countTotal();
        },

    },

    watch: {
        /**
         * listens to the property of add to cart
         * add to cart signal is coming from different (KitInfo) component 
         */
        isAddToCart(newVal) {
            if(newVal){
                this.$emit('addedToCart');
                this.kitToCart();
            }
        },
    },

    created(){
    },

    beforeUpdate() {
        this.itemRefs = []
    },

    updated() {
        this.countTotal();
        // console.table(this.kit_items);
    }
}
</script>